import type { PlayerWallet } from '../gameplay/wallet';

export class CurrencyBadge {
  readonly element: HTMLElement;
  private readonly balanceEl: HTMLElement;
  private readonly floaterEl: HTMLElement;
  private readonly unsubscribe: () => void;
  private floaterTimeout: number | null = null;

  constructor(wallet: PlayerWallet) {
    this.element = document.createElement('div');
    this.element.className = 'currency-badge';

    const symbol = document.createElement('div');
    symbol.className = 'currency-symbol';
    symbol.innerHTML = `
<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
  <defs>
    <linearGradient id="cred-g" x1="0" y1="0" x2="0" y2="1">
      <stop offset="0" stop-color="#ffe8a0"/>
      <stop offset="1" stop-color="#c08d1a"/>
    </linearGradient>
  </defs>
  <polygon points="12,2 21,7 21,17 12,22 3,17 3,7" fill="url(#cred-g)" stroke="#5a3f08" stroke-width="1"/>
  <text x="12" y="16" text-anchor="middle" font-family="Inter, sans-serif" font-size="10" font-weight="700" fill="#2a1a03">◎</text>
</svg>`;

    const label = document.createElement('div');
    label.className = 'currency-label';
    label.textContent = 'CREDITS';

    this.balanceEl = document.createElement('div');
    this.balanceEl.className = 'currency-balance';
    this.balanceEl.textContent = '0';

    const body = document.createElement('div');
    body.className = 'currency-body';
    body.append(label, this.balanceEl);

    this.floaterEl = document.createElement('div');
    this.floaterEl.className = 'currency-floater';

    this.element.append(symbol, body, this.floaterEl);

    this.unsubscribe = wallet.subscribe((snap) => {
      this.balanceEl.textContent = snap.balance.toLocaleString('en-US');
      if (snap.lastDelta !== 0) this.flashDelta(snap.lastDelta);
    });
  }

  dispose(): void {
    this.unsubscribe();
    if (this.floaterTimeout) window.clearTimeout(this.floaterTimeout);
    this.element.remove();
  }

  private flashDelta(delta: number): void {
    if (delta === 0) return;
    this.floaterEl.textContent = delta > 0 ? `+${delta}` : `${delta}`;
    this.floaterEl.classList.toggle('is-positive', delta > 0);
    this.floaterEl.classList.toggle('is-negative', delta < 0);
    this.floaterEl.classList.remove('is-visible');
    // restart animation
    void this.floaterEl.offsetWidth;
    this.floaterEl.classList.add('is-visible');
    if (this.floaterTimeout) window.clearTimeout(this.floaterTimeout);
    this.floaterTimeout = window.setTimeout(() => {
      this.floaterEl.classList.remove('is-visible');
    }, 1600);
  }
}
